import { EVENT_NAME_MAP } from '../constants/event-name-map.const';
import { EventName } from '../constants/event-name.const';
import { MetricType } from '../constants/metric-type.const';
import { IAddEventData } from '../interfaces/add-event-data.interface';

export function getApiRequestEventData(data: Partial<{ status_code: number; action: MetricType; type: string }>): Partial<IAddEventData> {
  const statusCode = data.status_code.toString();
  
  return {
    '@type': EVENT_NAME_MAP.get(EventName.FrontendLkApiRestRequests),
    name: EventName.FrontendLkApiRestRequests,
    labels: {
      ...data,
      status_code: statusCode,
      is_success: statusCode[0] === '2' ? 'true' : 'false',
      is_business_metric: false,
    },
    value: 1,
  };
}
